import { render, staticRenderFns } from "./CreateTournament.vue?vue&type=template&id=8fbe19ae&scoped=true"
import script from "./CreateTournament.vue?vue&type=script&lang=js"
export * from "./CreateTournament.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./CreateTournament.vue?vue&type=style&index=1&id=8fbe19ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fbe19ae",
  null
  
)

export default component.exports